// extracted by mini-css-extract-plugin
module.exports = {"modal":"__1nJa0YGS","hidden":"EeP_FjDy","okButton":"yS_4EoKD","cancelButton":"SzFkb9vC"};